// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios' //主要Ajax套件
import VueAxios from 'vue-axios' //轉為Vue 套件
import router from './router'
import VueCarousel from 'vue-carousel'

import member_title from '@/assets/icons/member_title.png';
Vue.use(VueCarousel);
Vue.use(VueAxios, axios) //用use執行套用
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: {
    member_title_url: member_title
  }
})



// WEBPACK FOOTER //
// ./src/main.js